<div class="columns is-multiline">
    <div class="column is-full">
        <grt-body-header>What is GrETEL?</grt-body-header>
    </div>
    <div class="column is-full">
        <grt-home-content></grt-home-content>
    </div>
</div>

